// Sonner wrapper themed for Bloom. Apps mount <Toaster /> once at root.
import { Toaster as SonnerToaster, toast } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "rounded-xl border border-[var(--brand-border)] bg-[var(--brand-paper)] text-[var(--brand-ink)] shadow-lg",
        },
      }}
    />
  );
}

export { toast };
